import { type CarrierDef } from '../common.js'
import { hjbt, type hjbtCredType } from './hjbt.js'

export type jbhuCredType = hjbtCredType
export const jbhu: CarrierDef<jbhuCredType> = {
  ...hjbt,
  scac: 'jbhu',
}
